module.exports = __webpack_public_path__ + "static/media/flat-tire-banesco.755a34bc.svg";